import auth from './auth'
import file from './file'
import messages from './messages'
import axios from 'axios'
import vm from '~/main'
import _ from 'lodash'

export default {
  namespaced: true,
  modules: {
    auth,
    file,
    messages,
  },
  state: {
    chatUsersOnline: [],
    chatsList: [],
    chatSocketIo: null,
    chatsConfig: {
      files: {
        max_size: 1048576 * 30, //30mb
        accepted: {
          image: ['.jpeg', '.png', '.jpg', '.gif'],
          application: ['.pdf', '.xls', '.doc', '.docx'],
          video: ['.mp4', '.webm'],
          audio: ['.mp3', '.webm'],
        },
      },
    },
    chatIsLoading: false,
    chatChangeNotificationLoading: false,
    chatKick: null,
    chatAxiosHeaders: () => {
      return {
        Authorization: 'Bearer ' + vm.$cookies.get('chat_token'),
      }
    },
    chatTranslations: () => vm.localStorage && vm.localStorage.translations.pages.chat.all,
  },
  getters: {
    chatsListFormatted(state) {
      const commonUserAll = vm.$store.state.commonUser.commonUserAll
      const currentUserId = vm.$store.state.user.user.id
      const chatApiDomain = vm.$store.state.chatApiDomain
      const chatTranslations = state.chatTranslations()
      // const copyArray = _.uniq(state.chatsList)

      const recipientsFormatData = (chat) => {
        for (let participant of chat.participants) {
          const participantUserData = commonUserAll.find((i) => i.id === participant.userId)
          if (participantUserData !== undefined) {
            participant.user = Object.assign({}, participant.user, participantUserData)
            if (participant.user.isUserDelete) {
              vm.$delete(participant.user, 'isUserDelete')
            }
            if (state.chatUsersOnline.includes(participant.user.id)) {
              vm.$set(participant.user, 'wasOnlineAt', 'online')
            }
          } else {
            vm.$set(participant.user, 'isUserDelete', true)
          }
          if (participant.user.id === currentUserId) {
            chat.currentUser = participant
          } else {
            if (chat.type === 'PERSONAL') {
              chat.interlocutorUser = participant
            }
          }
        }
      }

      const aboutInformationChat = (chat) => {
        if (!chat.displayData) {
          chat.displayData = {
            info:
              chat.type === 'PERSONAL'
                ? chat.interlocutorUser.user.isUserDelete
                  ? null
                  : chat.interlocutorUser.user.work_role ||
                    vm.localStorage.translations.pages.personnel_department.employees_card[
                      'dolzhnost-ne-naznachena'
                    ]
                : chatTranslations[
                    chat.metadata && chat.metadata.userGroup
                      ? (chat.metadata.userGroup.type === 'project' && 'project_chat') ||
                        (chat.metadata.userGroup.type === 'employeeGroup' && 'employeegroup_chat')
                      : 'group'
                  ],
          }
        }
        chat.displayData.name =
          chat.type === 'PERSONAL'
            ? chat.interlocutorUser && chat.interlocutorUser.user.isUserDelete
              ? chatTranslations.deleted_user
              : chat.interlocutorUser.user.first_name + ' ' + chat.interlocutorUser.user.last_name
            : chat.title
        chat.displayData.photo =
          chat.type === 'PERSONAL'
            ? (chat.interlocutorUser.user && chat.interlocutorUser.user.photo) || ''
            : chat.picture &&
              chatApiDomain + '/static/' + chat.picture.name + chat.picture.extension
      }

      const checkActionEnabled = (chat) => {
        chat.actionEnabled =
          chat.type === 'GROUP'
            ? !!chat.currentUser
            : chat.interlocutorUser.user.isUserDelete
            ? chat.interlocutorUser.user.isUserDelete !== true
            : true
      }
      return state.chatsList.length
      ? state.chatsList
          .map((chat) => {
            recipientsFormatData(chat)
            aboutInformationChat(chat)
            checkActionEnabled(chat)
            return chat
          })
          .sort((a, b) =>
            (a.messages.length ? a.lastMessage.sentAt : a.createdAt) <
            (b.messages.length ? b.lastMessage.sentAt : b.createdAt)
              ? 1
              : -1,
          )
      : []
    },
  },
  mutations: {
    SET_chatIsLoading(state, payload) {
      state.chatIsLoading = payload
    },
    SET_chatSocketIo(state, payload) {
      state.chatSocketIo = payload
    },
    SET_pushChatInList(state, payload) {
      state.chatsList.push(payload)
    },
    SET_chatsList(state, payload) {
      state.chatsList = payload
    },
    SET_GET_chatById(state, payload) {
      state.chatsList.push(payload)
    },
    SET_CREATE_chat(state, { chat, users }) {
      let findChatIndex = state.chatsList.findIndex((i) => i.id === chat.id)
      // console.log('users', users)
      if (findChatIndex === -1) {
        if (!chat.messages) {
          chat.messages = []
        }
        if (!chat._count) {
          chat._count = { messages: 0 }
        }
        if (!chat.participants && users) {
          chat.participants = []
          for (let user of users) {
            const userData = {
              userId: user.id,
              chatId: chat.id,
              isAdmin: false,
              isNotificationsEnabled: true,
              isHistoryAvailable: true,
              joinedAt: chat.createdAt,
              leftAt: null,
            }
            chat.participants.push(userData)
          }
        }
        if (chat.type === 'PERSONAL') {
          const currentUserId = vm.$store.state.user.user.id
          const peerId = chat.participants.find((p) => p.userId !== currentUserId).userId
          let uncreateChatIndex = state.chatsList.findIndex((i) => i.id === 'personal_' + peerId)
          // console.log('uncreateChatIndex', uncreateChatIndex)
          if (uncreateChatIndex > -1) {
            vm.$set(state.chatsList, uncreateChatIndex, chat)
          } else {
            state.chatsList.push(chat)
          }
        } else {
          state.chatsList.push(chat)
          // vm.$router.push({ name: 'chatById', params: { id: chat.id } })
        }
      }
    },
    SET_EDIT_chat(state, response) {
      const findChatIndex = state.chatsList.findIndex((i) => i.id === response.id)
      const findChat = state.chatsList[findChatIndex]
      if (findChat) {
        for (let objName of Object.keys(response)) {
          if (findChat[objName] !== response[objName]) {
            vm.$set(findChat, objName, response[objName])
          }
        }
      }
    },
    async SET_DELETE_chat(state, response) {
      const findChatIndex = state.chatsList.findIndex((i) => i.id === response.chat.id)
      // console.log('findChatIndex', findChatIndex)
      if (findChatIndex > -1) {
        if (vm.$route.params.id === response.chat.id) {
          await vm.$router.replace({ name: 'chat' })
        }
        vm.$delete(state.chatsList, findChatIndex)
      }
    },

    SET_chatGroupParticipant(state, response) {
      const findChatIndex = state.chatsList.findIndex((i) => i.id === response.chat.id)
      const findChat = state.chatsList[findChatIndex]
      const dowloadChatData = () =>
        vm.$store.dispatch('chat/GET_chatById', { chatId: response.chat.id })
      // const setDeleteChat = () => vm.$store.commit('chat/SET_DELETE_chat', response)
      const setChatKick = () => vm.$store.commit('chat/SET_chatKick', response.chat)
      const removeFunction = ({ userId, kick }) => {
        if (userId === vm.$store.state.user.user.id) {
          // setDeleteChat()
          if (kick) setChatKick()
        }
        const findParticipantIndex = findChat.participants.findIndex((i) => i.userId === userId)
        vm.$delete(findChat.participants, findParticipantIndex)
      }
      const jsonDateNow = new Date().toJSON()
      const addFunction = ({ chatId, userId }) => {
        const userData = {
          chatId,
          isAdmin: false,
          isHistoryAvailable: true,
          isNotificationsEnabled: true,
          joinedAt: jsonDateNow,
          leftAt: null,
          userId,
        }
        findChat.participants.push(userData)
      }

      switch (response.action) {
        case 'add':
          if (findChat) {
            if (response.targetUsers) {
              for (let user of response.targetUsers) {
                addFunction({ chatId: response.chat.id, userId: user.id })
              }
            } else if (response.targetUser) {
              addFunction({ chatId: response.chat.id, userId: response.targetUser.id })
            }
          } else {
            dowloadChatData()
          }
          break
        case 'remove':
          if (response.targetUsers) {
            for (let user of response.targetUsers) {
              removeFunction({ userId: user.id, kick: true })
            }
          } else if (response.targetUser) {
            removeFunction({ userId: response.targetUser.id })
          }
          break
        case 'softRemove':
          if (response.targetUser) {
            removeFunction({ userId: response.targetUser.id })
          }
          break
      }
    },
    SET_chatKick(state, response) {
      state.chatKick = response
    },
    SET_chatUsersOnline(state, { online, userId, type }) {
      // console.log('payload', { online, userId, type })
      const changeUserOnlineStatusInChats = (status) => {
        state.chatsList.forEach((i) => {
          const findUser = i.participants.find((i) => i.user.id === userId)
          if (findUser) {
            vm.$set(findUser.user, 'wasOnlineAt', status)
          }
        })
      }
      if (online) {
        state.chatUsersOnline = online
      } else if (userId && type) {
        if (type === 'registered' && !state.chatUsersOnline.includes(userId)) {
          state.chatUsersOnline.push(userId)
          changeUserOnlineStatusInChats('online')
        } else if (type === 'disconnected') {
          const index = state.chatUsersOnline.indexOf(userId)
          if (index > -1) {
            state.chatUsersOnline.splice(index, 1)
          }
          const offlineDate = new Date().toISOString()
          changeUserOnlineStatusInChats(offlineDate)
        }
      }
      // console.log('SET_chatUsersOnline result', state.chatUsersOnline)
    },
    SET_userIsTypingDelete: _.debounce(function (state, { userId, findChat }) {
      vm.$delete(findChat.usersIsTyping, userId)
    }, 3000),
    SET_userIsTyping(state, { userId, chatId }) {
      const findChat = state.chatsList.find((i) => i.id === chatId)
      if (findChat) {
        if (!findChat.usersIsTyping) {
          vm.$set(findChat, 'usersIsTyping', {})
        }
        if (!findChat.usersIsTyping[userId]) {
          vm.$set(
            findChat.usersIsTyping,
            userId,
            findChat.participants.find((i) => i.user.id === userId).user,
          )
        }
        vm.$store.commit('chat/SET_userIsTypingDelete', { userId, findChat })
      }
    },
    SET_chatIdMedia(state, { resp: { count, data }, chat, actionType }) {
      // console.log('SET_chatIdMedia', { resp: { count, data }, chat, actionType })
      if (chat) {
        if (actionType === 'get') {
          // console.log('SET_chatIdMedia GET')
          if (!chat.attachments) {
            vm.$set(chat, 'attachments', { count, data })
          } else {
            if (data.length) {
              const attachmentsData = chat.attachments.data
              vm.$set(chat.attachments, 'data', [...attachmentsData, ...data])
            }
          }
        } else if (actionType === 'add') {
          // console.log('SET_chatIdMedia ADD')
          if (chat.attachments) {
            data.forEach((attachment) => {
              let formatFile = attachment.file
              if (formatFile) {
                formatFile.attachedTo = [
                  {
                    fileId: attachment.fileId,
                    messageId: attachment.messageId,
                  },
                ]
                chat.attachments.data.unshift(formatFile)
                vm.$set(chat.attachments, 'count', chat.attachments.count + 1)
              }
            })
          }
        } else if (actionType === 'delete') {
          // console.log('SET_chatIdMedia DELETE')
          if (chat.attachments) {
            data.forEach((attachment) => {
              const deletedFileIndex = chat.attachments.data.findIndex(
                (i) => i.id === attachment.fileId,
              )
              vm.$delete(chat.attachments.data, deletedFileIndex)
              vm.$set(chat.attachments, 'count', chat.attachments.count - 1)
            })
          }
        }
      }
    },
  },
  actions: {
    GET_chatsList({ rootState, commit, state }) {
      // console.log('state.chatAxiosHeaders()', state.chatAxiosHeaders())
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.chatApiDomain + '/v1/chat?take=0&takeMessages=30',
          method: 'GET',
          headers: state.chatAxiosHeaders(),
        })
          .then((resp) => {
            commit('SET_chatsList', resp.data)
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    GET_chatById({ rootState, commit, state }, { chatId }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.chatApiDomain + '/v1/chat/' + chatId,
          method: 'GET',
          headers: state.chatAxiosHeaders(),
        })
          .then((resp) => {
            commit('SET_GET_chatById', resp.data)
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    CREATE_chatPersonal({ rootState, state }, { data }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/personal',
          method: 'POST',
          data,
          headers: state.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('CREATE_chatPersonal', resp)
            // commit('SET_CREATE_chat', { chat: resp.data, peerId: data.peerId })
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    CREATE_chatGroup({ rootState, state }, { data }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/group',
          method: 'POST',
          data,
          headers: state.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('CREATE_chatGroup', resp)
            // commit('SET_CREATE_chat', { chat: resp.data })
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    EDIT_chatGroup({ rootState, commit, state }, { data }) {
      const id = data.id
      delete data.id
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/' + id,
          method: 'PUT',
          data,
          headers: state.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('EDIT_chatGroup', resp)
            commit('SET_EDIT_chat', resp.data)
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    DELETE_chat({ rootState, state }, { chatId, isSoftDelete }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/' + chatId,
          method: 'DELETE',
          headers: state.chatAxiosHeaders(),
        }
        if (isSoftDelete !== undefined) {
          config.data = {
            isSoftDelete,
          }
        }
        axios(config)
          .then((resp) => {
            // console.log('DELETE_chat', resp)
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    CHANGE_chatNotification({ rootState, state }, { chatId, useSwitch }) {
      // state.chatChangeNotificationLoading = true
      const currentUserId = rootState.user.user.id
      const findChatIndex = state.chatsList.findIndex((i) => i.id === chatId)
      const findUserInChat = state.chatsList[findChatIndex].participants.find(
        (i) => i.userId === currentUserId,
      )
      let userNotificationsStatus = findUserInChat.isNotificationsEnabled
      const checkUseSwitch = useSwitch ? userNotificationsStatus : !userNotificationsStatus
      let action = checkUseSwitch ? 'enable' : 'disable'
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/' + chatId + '/notifications/' + action,
          method: 'PUT',
          headers: state.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('CHANGE_chatNotification', resp)
            resolve(resp.data)
            findUserInChat.isNotificationsEnabled = checkUseSwitch
            // state.chatChangeNotificationLoading = false
          })
          .catch((err) => {
            reject(err)
            findUserInChat.isNotificationsEnabled = !checkUseSwitch
            // state.chatChangeNotificationLoading = false
          })
      })
    },
    ADD_chatGroupParticipant({ rootState, state }, { userIds, chatId, isHistoryAvailable }) {
      let data = { userIds, chatId, isHistoryAvailable: isHistoryAvailable || true }
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/group/add',
          method: 'PUT',
          data,
          headers: state.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('ADD_chatGroupParticipant', resp)
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    DELETE_chatGroupParticipant({ rootState, state }, { userIds, chatId, isHistoryAvailable }) {
      let data = { userIds, chatId, isHistoryAvailable: isHistoryAvailable || true }
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/group/remove',
          method: 'PUT',
          data,
          headers: state.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('DELETE_chatGroupParticipant', resp)
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    LEAVE_chatGroup({ rootState, state }, { chatId }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/group/' + chatId + '/leave',
          method: 'PUT',
          headers: state.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('LEAVE_chatGroup', resp)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    GET_chatIdMedia({ rootState, state, commit }, { chatId, take }) {
      const findChat = state.chatsList.find((i) => i.id === chatId)
      return new Promise((resolve, reject) => {
        let url = rootState.chatApiDomain + '/v1/chat/' + chatId + '/media?take=' + (take || 15)
        if (findChat?.attachments?.data.length > 0) {
          url =
            url + '&cursor=' + findChat.attachments.data[findChat.attachments.data.length - 1].id
        }
        let config = {
          url,
          method: 'GET',
          headers: rootState.chat.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            resolve(resp.data)
            let data = {
              resp: resp.data,
              chat: findChat,
              actionType: 'get',
            }
            commit('SET_chatIdMedia', data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
